import React, { useContext } from 'react'
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TextField } from '@mui/material';
import axios from "axios"
import { Box } from '@mui/system';
import { AuthContext } from '../authContext/AuthContext';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const DetailsItem = ({detailsDialog, handleClose, detailsItemId}) => {
    const [itemKey,setItemKey] = React.useState("");
    const [itemName,setItemName] = React.useState("");
    const [displayName,setDisplayName] = React.useState("");
    const [itemMainCategory,setItemMainCategory] = React.useState("");
    const [itemSubCategory,setItemSubCategory] = React.useState("");
    const [itemSubsubCategory,setItemSubsubCategory] = React.useState("");
    const [stock,setStock] = React.useState(0);
    const [itemClass,setItemClass] = React.useState("Class A");
    const [sellingPriceExclTax,setSellingPriceExclTax] = React.useState(0.00);
    const [sellingPriceInclTax,setSellingPriceInclTax] = React.useState(0.00);
    const [sgst,setSgst] = React.useState(2.5);
    const [cgst,setCgst] = React.useState(2.5);
    const [igst,setIgst] = React.useState(0.0);
    const [unitOfMeasurement, setUnitOfMeasurement] = React.useState("Kilograms");
    const [isActive,setIsActive] = React.useState(true);
    const {user, shop} = useContext(AuthContext)

    React.useEffect(() => {
      const getItem = async() => {
        if(detailsItemId) {
          try {
            const res = await axios.get("/items/find/" + detailsItemId, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
            setItemKey(res.data.itemKey)
            setItemName(res.data.itemName)
            setDisplayName(res.data.displayName)
            setItemMainCategory(res.data.itemMainCategory)
            setItemSubCategory(res.data.itemSubCategory)
            setItemSubsubCategory(res.data.itemSubsubCategory)
            setStock(res.data.stock)
            setItemClass(res.data.itemClass)
            setSellingPriceExclTax(res.data.sellingPriceExclTax)
            setSellingPriceInclTax(res.data.sellingPriceInclTax)
            setSgst(res.data.sgst)
            setCgst(res.data.cgst)
            setIgst(res.data.igst)
            setUnitOfMeasurement(res.data.unitOfMeasurement)
            setIsActive(res.data.active)
          } catch (err) {
            console.log(err)
          }
        }
      };
      getItem();
    },[detailsItemId, user, shop]);

    return (
      <div>
        <Dialog open={detailsDialog} onClose={handleClose} TransitionComponent={Transition} sx={{width: "100vw"}}>
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
              <IconButton edge="start" color="inherit"onClick={handleClose}aria-label="close"><CloseIcon /></IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Item Details</Typography>
            </Toolbar>
          </AppBar>
          <Box sx={{margin: "2vh"}}>
            <Grid container spacing={2}>
              <Grid item xs={12}><TextField label="Item Key" variant="standard" fullWidth disabled value={itemKey}/></Grid>
              <Grid item xs={12}><TextField label="Item Name" variant="standard" fullWidth disabled value={itemName}/></Grid>
              <Grid item xs={12}><TextField label="Display Name" variant="standard" fullWidth disabled value={displayName}/></Grid>
              <Grid item xs={12}><TextField label="Item Class" variant="standard" fullWidth disabled value={itemClass}/></Grid>
              <Grid item xs={12}><TextField label="Main Category" variant="standard" fullWidth disabled value={itemMainCategory}/></Grid>
              <Grid item xs={12}><TextField label="Sub Category" variant="standard" fullWidth disabled value={itemSubCategory}/></Grid>
              <Grid item xs={12}><TextField label="Sub Sub Category" variant="standard" fullWidth disabled value={itemSubsubCategory}/></Grid>
              <Grid item xs={3}><TextField label="SP Incl Tax" variant="standard" fullWidth disabled value={sellingPriceInclTax}/></Grid>
              <Grid item xs={2}><TextField label="CGST" variant="standard" fullWidth disabled value={cgst}/></Grid>
              <Grid item xs={2}><TextField label="SGST" variant="standard" fullWidth disabled value={sgst}/></Grid>
              <Grid item xs={2}><TextField label="IGST" variant="standard" fullWidth disabled value={igst}/></Grid>
              <Grid item xs={3}><TextField label="SP Excl Tax" variant="standard" fullWidth disabled value={sellingPriceExclTax}/></Grid>
              <Grid item xs={5}><TextField label="Stock" variant="standard" fullWidth disabled value={stock}/></Grid>
              <Grid item xs={5}><TextField label="Unit Type" variant="standard" fullWidth disabled value={unitOfMeasurement}/></Grid>
              <Grid item xs={2}><TextField label="Active" variant="standard" fullWidth disabled value={isActive}/></Grid>
            </Grid>
          </Box>
        </Dialog>
      </div>
    )
}

export default DetailsItem
